import { Component, OnInit } from '@angular/core'
import { SharedService } from '../../../services/shared/shared.service'
import { BaseCountry } from '../../../models/enum/country.enum'

@Component({
    selector: 'app-minimum-dispatch-time',
    templateUrl: './minimum-dispatch-time.component.html',
    styleUrls: ['./minimum-dispatch-time.component.scss'],
    standalone: false
})
export class MinimumDispatchTimeComponent implements OnInit {
  public baseSite: string = 'AU'
  public dispatchHours: string = '48'

  constructor(private sharedService: SharedService) {}

  ngOnInit(): void {
    if (this.sharedService.baseSiteId == BaseCountry.NZ) {
      this.baseSite = 'NZ'
      this.dispatchHours = '24'
    }
  }
}
